import React from 'react';

const LinkItem = ({ dataId, name, onClick }) => {
  return (
    <div>
      <li>
        <a onClick={onClick} data-id={dataId} style={{ cursor: 'pointer' }}>
          {name}{' '}
        </a>
      </li>
    </div>
  );
};

export default LinkItem;
